<template>
  <div class="row mb-1">
    <div id="emotion" class="col-md-12 px-gap">
      <div class="card card-default shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Emosi</h4>
                <p class="small hint-text">Data Persentase dan Tren Emosi</p>
              </div>
              <div class="pull-right">
                <div class="form-check form-check-inline switch m-t-20">
                  <input type="checkbox" id="show-bar-emotion" v-model="show_bar_emotion" />
                  <label for="show-bar-emotion">Tampilkan Grafik Bar</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 col-sm-12">
              <loader-component v-if="data_series == null" />
              <pie-chart-component chart_id="pie-emotion" :data="data_stats" />
            </div>
            <div class="col-md-9 col-sm-12">
              <div v-if="!show_bar_emotion">
                <loader-component v-if="data_series == null" />
                <div v-else-if="Object.keys(data_series.y).length === 0" class="alert alert-danger" id="errorApiEl"
                  role="alert" align="center">
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <line-chart-component v-else :series="data_series" el="linechart-emotion" mode="single" />
              </div>
              <div v-else>
                <bar-chart-component :data="data_series" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import line_chart from "@/views/components/chart/line_chart.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";
import loader_component from "@/views/components/loader.vue";

export default {
  name: "persentase_tren_emotion",
  components: {
    "line-chart-component": line_chart,
    "pie-chart-component": pie_chart,
    "bar-chart-component": bar_chart_horizontal,
    "loader-component": loader_component,
  },
  props: {
    data: Object,
    stats: Array,
  },
  data() {
    return {
      data_series: this.data,
      show_bar_emotion: false,
      data_stats: this.stats,
    };
  },
};
</script>
